import { render } from "./VehicleDeviationFormDialogHeader.vue?vue&type=template&id=0974380a"
import script from "./VehicleDeviationFormDialogHeader.vue?vue&type=script&lang=ts"
export * from "./VehicleDeviationFormDialogHeader.vue?vue&type=script&lang=ts"
script.render = render

export default script
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QBtn});
